import { DeliveryPriceAndDateOption } from 'src/types';
import { moneyBuilder } from './money';

const defaults: Readonly<DeliveryPriceAndDateOption> = {
  date: '2021-07-31',
  exactDate: true,
  exceptionalProductDeliveryInformation: null,
  max: null,
  min: null,
  optionCode: 'STANDARD',
  prices: [moneyBuilder()],
  productCodes: [0],
  deliveryProvider: {
    name: 'Other Provider',
  },
};

export const deliveryPriceAndDateOptionBuilder = (
  overrides?: Partial<DeliveryPriceAndDateOption>,
): Readonly<DeliveryPriceAndDateOption> => ({ ...defaults, ...overrides });
